
import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import CategoryAdd from "../screens/CategoryManagement/CategoryAdd";

const breadCrumbData = [{ link: "/category-list", name: "Project List" },
{ link: "/category-add", name: "Add Project" }];

const CategoryManagement = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <CategoryAdd />
    </LayoutContainer>
  </>
);

export default CategoryManagement;